var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.testOn && _vm.testBBB)?_c('video',{attrs:{"controls":"","autoplay":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }